import { useState, useRef, useEffect } from 'react'
import { createModel } from 'hox'
import { useMap } from 'ahooks';
import { totalModel } from '../total/totalModel'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { settleService } from '../../settleService'
import { OrderDetailResult, CustomerField } from '../../settleTypes'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'

export const detailModel = createModel(function () {

    const { franchiseeCode } = totalModel();

    //列表数据源
    const [dataSource, setDataSource] = useState<OrderDetailResult[]>([])
    const [statistics, setStatistics] = useState<CustomerField[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<OrderDetailResult[]>([]);
    //表单数据
    const [formInfo, { set: setFormInfo, get: getFormInfo }] = useMap<string, any>([]);
    //弹窗可见
    const [mode, setMode] = useState<string>("add") //add、edit
    const [visible, setVisible] = useState<boolean>(false)
    const [loading, setLoading] = useState(false)
    //发起结算表单
    const [formValues, setFormValues] = useState<any>(null);

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    //列表数据
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: any = searchParam) => {
        setLoading(true)
        const searchParams = {
            searchItem: {
                ...searchValue,
                "franchiseeCode": franchiseeCode,
            },
            pageSize: page?.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orders: [{ column: 'createTime', rule: 'DESC' }],
        }
        let { retData } = await settleService.detail(searchParams)
        const { list, ...pg } = retData

        const newList = list.map(item => {
            let obj: any = {}
            item.fields.forEach((e) => {
                obj[e.fieldCode] = e.fieldValue
            })
            return { ...item, ...obj };
        })
        setDataSource(newList)

        let { retData: statis } = await settleService.statistics(searchParams);
        setStatistics(statis);

        setPgCfg(transPgToPagination(pg))
        setLoading(false)
    }

    //设置搜索value
    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    //获取一条详情数据 Api
    const getOne = async (mode: string, id: string) => {
        let { retData } = await settleService.one(id)
        const { ...formVal } = retData
        retData && setFormInfo(mode, { ...formVal });
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        statistics,
        selectedRowKeys,
        selectedData,
        pgCfg,
        visible,
        mode,
        formInfo,
        loading,
        formValues,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        setSelectedData,
        resetSearchParam,
        updateSearchParam,
        loadData,
        getOne,
        setVisible,
        setMode,
        setFormInfo,
        getFormInfo,
        setFormValues,
    }
})
